module.exports = __webpack_public_path__ + "static/media/yUSD-logo.738494d0.png";